import { writeToString } from '@fast-csv/format';
import FileSaver from 'file-saver';

const downloadCsv = async (csvHeaders, rows, fileName) => {
  const csvRows = rows.map((row) => (
    csvHeaders.map((header) => row[header])
  ));

  const csvString = await writeToString(csvRows, { headers: csvHeaders });
  // Add UTF-8 BOM for compatibility
  const UTF8_BOM = '\uFEFF';
  const csvStringWithBOM = UTF8_BOM + csvString;
  const csvFileType = 'text/csv;charset=utf-8;';
  const blob = new Blob([csvStringWithBOM], { type: csvFileType });

  const outputFileName = `${fileName}.csv`;

  FileSaver.saveAs(blob, outputFileName);
};

export {
  downloadCsv,
};
